<template>
<div class="pin-books">

    <div class="row">
        <div v-for="book in books" :key="book.id" class="pin-book-item col-md-6 col-lg-4 py-3 mb-5">
            <pin-book-editor v-if="book.user_id === user.id" :pin-book="book"></pin-book-editor>
            <div class="rounded-lg bg-gradient bg-light">
                <div class="card pin-book-card shadow text-center">
                    <div class="card-header"><strong>{{ book.name }} <i v-if="book.is_private" class="ms-2 fa-solid fa-lock" title="Private Pin Book"></i></strong></div>

                        <a v-if="book.image" :href="'/pin-books/' + book.id + '/' + book.slug"><picture>
                            <!-- <source :srcset="'https://pinandpop.s3.amazonaws.com' + book.image.thumbs.webp" type="image/webp">
                            <source :srcset="'https://pinandpop.s3.amazonaws.com' + book.image.thumbs.jpg" type="image/jpeg">
                            <img :src="'https://pinandpop.s3.amazonaws.com' + book.image.thumbs.jpg" class="img-fluid card-img-top shadow mt-2" :alt="book.name" style="max-height: 250px; width: auto;"> -->
                            <source :srcset="book.image.srcset.webp" type="image/webp">
                            <source :srcset="book.image.srcset.jpg" type="image/jpeg">
                            <img :src="book.image.srcset.jpg" class="img-fluid card-img-top shadow mt-2" :alt="book.name" style="max-height: 250px; width: auto;">
                        </picture></a>

                    <div class="card-body">
                        <h5 class="card-title text-center"><a :href="'/pin-books/' + book.id + '/' + book.slug" class="">{{ book.name }}</a></h5>

                        <div v-if="book.pins_count" class="row d-md-none d-lg-flex">
                            <div v-for="(pin, idx) in book.pins" :key="pin.id" class="col-4 my-2 text-center">
                                <a v-if="idx < 6" :href="'/pins/' + pin.id">
                                    <picture>
                                        <!-- <source :srcset="'https://pinandpop.s3.amazonaws.com' + pin.primary_image.thumbs.webp" type="image/webp">
                                        <source :srcset="'https://pinandpop.s3.amazonaws.com' + pin.primary_image.thumbs.jpg" type="image/jpeg">
                                        <img :src="'https://pinandpop.s3.amazonaws.com' + pin.primary_image.thumbs.jpg" class="img-fluid shadow" :alt="pin.name" style="max-height: 60px"> -->
                                        <source :srcset="pin.cover.srcset.webp" type="image/webp">
                                        <source :srcset="pin.cover.srcset.jpg" type="image/jpeg">
                                        <img :src="pin.cover.srcset.jpg" class="img-fluid shadow" :alt="pin.name" style="max-height: 60px">
                                    </picture></a>
                            </div>
                        </div>

                        <div class="mt-2 text-center">

                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col text-muted d-flex justify-content-between">
                                <span><strong>{{ book.pins_count }}</strong> Pin<template v-if="book.pins_count > 1">s</template></span>

                                <a v-if="user.id && user.id !== book.user_id" @click.prevent="toggleFavorite(book)" href="#" class="text-muted">
                                    <i v-if="book.is_favorite" class="fa-solid fa-heart fa-lg text-danger"></i>
                                    <i v-else class="fa-regular fa-heart"></i></a>
                                <!-- {{ book.favorite_users_count }}</a> -->
                                <!-- <span v-else>
                                    <i class="fa-solid fa-heart"></i> {{ book.favorite_users_count }}
                                </span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <pin-book-controls @updated="updatedBook" :editor="true" :user="user" :enh="enh"></pin-book-controls>

</div>
</template>

<script>
import PinBookControls from "./PinBookControls.vue";
import PinBookEditor from "./PinBookEditor.vue";

export default {
    name: 'PinBooks',
    props: {
        pinBooks: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        enh: {
            type: Boolean,
            default: false
        },
    },
    components: {
        PinBookControls,
        PinBookEditor
    },
    data: function() {
        return {
            books: this.pinBooks
        }
    },
    methods: {

        updatedBook (book) {
            let index = this.books.findIndex(b => b.id === book.id);

            this.books[index].name = book.name;
            this.books[index].slug = book.slug;
            this.books[index].is_private = book.is_private;
        },

        toggleFavorite (book) {
            book.is_favorite = !book.is_favorite;

            if (book.is_favorite) {
                axios.post('/api/pin-books/' + book.id + '/fav').then(response => {
                    if (response.status === 200) {
                        book.favorite_users_count += 1;
                    }
                }).catch(error => {
                    this.handleError(error);
                });
            } else {
                axios.delete('/api/pin-books/' + book.id + '/fav').then(response => {
                    if (response.status === 200) {
                        book.favorite_users_count -= 1;
                    }
                }).catch(error => {
                    this.handleError(error);
                });
            }
        },

        handleError (error) {
            if (error.response.status === 401) {
                window.location.href = '/login?intended='+window.location.pathname;
            } else if (error.response.status === 419) {
                window.location.reload();
            }
        }

    }
}
</script>
